import { Injectable } from '@angular/core';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { BearerHttpService } from '../../services/bearer-http.service';
//import { ModelService } from 'src/app/services/model.service';
import { PdfService } from 'src/app/services/pdf.service';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/app.config';
import { map } from 'rxjs/operators';
//import { ProjectDetailService } from '../project-detail/project-detail.service';
//import * as Daterangepicker from 'ng2-daterangepicker';
import { Utils } from 'src/app/utils.module';

@Injectable({
	providedIn: 'root'
})
export class ProjectListService {

	private projectList: ProjectData[];

	constructor(
		private http: BearerHttpService,
		//	private modelService: ModelService,
		//	private detailService: ProjectDetailService,
		private pdfService: PdfService
	) { }

	public getFilterProjects(filter: string): Observable<any> {
		let endPoint = '/api/configFilterProyecto/' + filter;
		return this.http.Get(ConfigService.REST_SERVER + endPoint)
			.pipe(
				map(res => {
					this.projectList = res["result"];
					this.projectList.map((project) => {
						// Transformar el string en Date.
						project.fechaCreacion = new Date(project.fechaCreacion);
						return project;
					});
					return { 
						projectList: this.projectList,
						count: res["count"]
					};
				},
					(error: any) => {
						console.log('error: ', error);
					}
				));
	}

	public getUsers(): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/user').pipe(map(res => { return res["result"]; }));
	}

	public getUsersActives(): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/userActives').pipe(map(res => { return res["result"]; }));
	}

	public getUsersCIA(cia: string): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/userCIA/' + cia).pipe(map(res => { return res["result"]; }));
	}

	// ADQUIRIR IMAGEN
	public getUnityProjectImage(project: ProjectData): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/configProyecto/' +
			project._id + '/imagen').pipe(map(res => { const imageBase64 = res["result"]; return imageBase64; }));
	}

	// ADQUIRIR PROYECTO
	public getProject(projectId: string): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/configProyecto/' + projectId)
		.pipe(
			map(res => {
				let project = res["result"];
				if (project === null) return null;
				let pd: ProjectData = new ProjectData();
				pd.estado = project.estado;
				pd.idioma = project.idioma;
				pd.mc = project.mc;
				pd.nombre = project.nombre;
				pd.perimetro = project.perimetro;
				pd.renderer = project.renderer;
				pd.satelite = project.satelite;
				pd.userId = project.userId;
				pd.userIdRivisa = project.userIdRivisa;
				pd._id = project._id;
				return project;
			},
			(error: any) => {
				console.log('error: ', error);
				return null;
			})
		);
	}

	// ELIMINAR PROYECYO
	public deleteProject(projectId: string): Observable<any> {
		return this.http.Delete(ConfigService.REST_SERVER + '/api/configProyecto/' + projectId)
			.pipe(
				map(rs => {
					const col = this.projectList;
					const len = col.length - 1;
					for (let i: number = len; i >= 0; i--) {
						if (col[i]._id === rs["result"]) {
							col.splice(i, 1);
						}
					}
					return true;
				}));
	}

	// Actualiza el MC del proyecto,esta acción solo se cumple en el listdo, por el momento.
	public saveMCProject(projectData: ProjectData): Observable<any> {
		return this.http.Post(ConfigService.REST_SERVER + '/api/configProyecto',
			{ configuracion: JSON.stringify(projectData), id: projectData._id })
			.pipe(
				map(res => {
					projectData._id = res["id"];
					return res;
				},
					(error: any) => {
						console.log('error: ', error);
					}));
	}

	public printProject(projectData: ProjectData): void {
		this.http.Get(ConfigService.REST_SERVER + '/generatePDF/' + projectData._id);
	}

	public downloadProject(projectData: ProjectData, conMC: boolean): void {
		this.updateView(projectData);

		this.pdfService.getPDF(projectData).subscribe(data => {
			if (data) {
				// this.createPDF(data.jpg.data);
				this.pdfService.createPDF(data, conMC);
			}
			else {
				// Error
				this.pdfService.createPDF(null, conMC);
			}
		});
		// this.http.get(ConfigService.REST_SERVER + ' /generate PDF/' + projectData._id + ' /' + this.modelService.getUser().getData().id);
		// this.detailService.getPDF(projectData, this.modelService.getUser().getData().id);
		return null;
	}

/*public applyFilters(userId: string, searchString: string, startDate: Date, endDate: Date, state: object): ProjectData[] {
	return this.filterByUser(userId,
		this.filterByName(searchString, this.filterByState(state, this.filterByDate(startDate, endDate, this.projectList))));
}*/

	private updateView(projectData: ProjectData): void {
		// this. projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
		// if (!this.projectData) { this.router.navigate([' /']); }
		// Actualizar alineamiento de los botones según estado y usuario.
		// this.actualizarBotones();

		// Comprobar si tiene MC (margen comercial).
		const tieneMC = (projectData.mc > 0);

		// projectData.perimetro = projectData.perimetro;
		projectData.perimetro.forEach((p) => {
			const grid = [];
			p.subtotal = 0;
			p.vat = -1;
			if (p.presupuesto.navision) {
				p.presupuesto.navision.response.segmento.vProductItem.forEach((item) => {
					if (item != null) {

						p.longitudStr = Utils.formatDecimal(p.longitud.toString(), 3);
						if (!p.longitudML) {
							p.longitudML = p.presupuesto.unity.ml;
						}
						p.presupuesto.unity.mlStr = Utils.formatDecimal(p.longitudML.toString(), 3);
						let canStr = item.cantidad;
						if (canStr.endsWith('.00')) {
							canStr = canStr.replace('.00', '');
						} else if (canStr.endsWith(',00')) {
							canStr = canStr.replace(',00', '');
						}
						const _cantidad = parseInt(canStr.replace(',', '').replace('.', ''), 10);
						const _precio = parseFloat(item.precio.replace(',', ''));
						if (p.vat === -1 && item.iva !== '-1.00') { p.vat = parseFloat(item.iva); }

						const _descuento = (item.descuento) ? parseInt(item.descuento.replace('%', ''), 10) : 0;
						let descontar = (_cantidad * _precio);
						if (_descuento > 0) {
							descontar -= (descontar / 100) * _descuento;
						}
						const tot = descontar.toFixed(2);
						p.subtotal += parseFloat(tot);

						grid.push({
							cod_producto: item.cod_producto,
							descripcion: item.descripcion,
							precio: Utils.formatDecimal(item.precio) + '€',
							descuento: _descuento + '%',
							cantidad: item.cantidad, // canStr,
							total: Utils.formatDecimal(tot) + '€'
						});
					}
				});
			} else {
				console.log('DETAILS ERROR NAVISION > perimetro.presupuesto.navision = null');
			}

			if (grid.length > 0) {
				// FIXME Calcular el mc SOLO si es para el cliente.
				if (tieneMC) {
					// Obtener el descuento sobre el precio total (perimetro.subtotal) sin impuestos.
					p.descuento = parseFloat(((p.subtotal / 100 * projectData.mc).toFixed(2)));
					// Restar el descuento.
					p.aplicado = p.subtotal - p.descuento;
					// Calcular el impuerto.
					p.vatTotal = parseFloat(((p.aplicado / 100) * p.vat).toFixed(2));
					// Obtener el resultadofinal.
					p.total = p.vatTotal + p.aplicado;
				} else {
					// Calcular el impuesto.
					p.vatTotal = parseFloat(((p.subtotal / 100) * p.vat).toFixed(2));
					// Obtener el resultadofinal.
					p.total = p.vatTotal + p.subtotal;
				}

				p.subtotalStr = Utils.formatDecimal(p.subtotal.toString());
				if (tieneMC) {
					p.descuentoStr = Utils.formatDecimal(p.descuento.toString());
					p.aplicadoStr = Utils.formatDecimal(p.aplicado.toString());
				}
				p.vatTotalStr = Utils.formatDecimal(p.vatTotal.toString());
				p.totalStr = Utils.formatDecimal(p.total.toString());
			}
			p.grid = grid;
		});
	}
}



//####################################################################################
//####################################################################################
//####################################################################################
/*public getProjects(isAdmin: boolean): Observable<any> {
	let endPoint = ' /api/ configProyecto/';
	if (!isAdmin) {
		const userId = this.modelService.getUser().getData().id;
		endPoint += userId + ' /proyectos';
	}

	return this.http.Get(ConfigService.REST_SERVER + endPoint + endPoint)
		.pipe(
			map(res => {
				this.projectList = res["result"];
				this.projectList.map((project) => {
					// FI XME ¿PORQUÉ?
					console.log(project.fecha Creacion);
					project.fecha Creacion = new Date(project.fech aCreacion);
					return project;
				});
				return this.projectList;
			}));
}*/

/*
	private filterByUser(searchString: string, collection: ProjectData[]): ProjectData[] {
	if (searchString !== '') {
		return collection.filter((project) => {
			return project.userId === searchString;
		});
	} else {
		return collection;
	}
}

	private filterByDate(startDate: Date, endDate: Date, collection: ProjectData[]): ProjectData[] {
	return collection;
	//return collection.filter((project) => {return project.fecha Creacion >= startDate && project.fecha Creacion <= endDate;});
}

	private filterByState(currentState: object, collection: ProjectData[]): ProjectData[] {
	if (currentState && currentState['value'] !== -1) {
		return collection.filter((project) => {
			return project.estado === currentState['value'];
		});
	} else {
		return collection;
	}
}

private filterByName(searchString: string, collection: ProjectData[]): ProjectData[] {
	if (searchString !== '') {
		return collection.filter((project) => {	return project.nombre.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase()) > -1; });
	} else { return collection; }
}

*/